import { useAuthStore } from '@/store/auth.store'

/**
 * Client-side feature-flag check. The backend delivers the enabled flags as
 * `features: string[]` in the login/refresh response (mirrored into the auth
 * store). A flag is "on" for this user iff its name is present in that list.
 *
 * Flags gate *not-yet-final* UI to a subset of users; permission gating
 * (`usePermissions`) is a separate concern (may this user do it at all).
 *
 * ```ts
 * const wizardEnabled = useFeatureFlag('ActionModuleEditor')
 * ```
 */
export function useFeatureFlag(flag: string): boolean {
  const features = useAuthStore((s) => s.features)
  return features?.includes(flag) ?? false
}
